import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoadingSpinner from 'components/loading_spinner';

import Records from './records';
import { getFileMapping } from '../store/selectors';
import { isLoadingRecords } from '../store/run_records_selectors';
import { retrieveRunRecords } from '../store/actions/run_records';
import ReadyToImportModal from './ready_to_import_modal';
import NewImportCancelModal from '../new_import_cancel_modal';

import './preview.scss';

export function Preview({
  fileMapping,
  loadingRecords,
  retrieveRunRecords
}) {
  const [showReadyToImportModal, setShowReadyToImportModal] = useState(false);

  const handleImportReadySubmit = () => {
    setShowReadyToImportModal(true);
  };

  useEffect(()  => {
    if (!fileMapping.id) return;
    retrieveRunRecords(1);
  }, [fileMapping]);

  const renderPreviewHeader = () => {
    return (
      <div className="mb-4">
        <h3 className="semi-bold mb-4">Preview Data</h3>
        <p className="mt-4">
          You can preview how your data will be imported into your database in the table below.
          If you need to fix any errors or edit your data, click on a field.
          If there is a record you do not want to import, uncheck that row.
        </p>
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <div className="p-0 mb-4">
        <NewImportCancelModal />
        <div className="btn btn-save ml-2" onClick={handleImportReadySubmit}>
          Save &amp; Continue
        </div>
      </div>
    );
  };

  return (
    <div className="preview">
      {renderPreviewHeader()}
      {loadingRecords ? <LoadingSpinner /> : <Records /> }
      {renderButtons()}
      <ReadyToImportModal
        shown={showReadyToImportModal}
        onClose={setShowReadyToImportModal}
      />
    </div>
  );
}

Preview.propTypes = {
  fileMapping: PropTypes.object.isRequired,
  loadingRecords: PropTypes.bool,
  retrieveRunRecords: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  fileMapping: getFileMapping(state),
  loadingRecords: isLoadingRecords(state)
});

const mapDispatchToProps = {
  retrieveRunRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
